import { render, staticRenderFns } from "./invoicesOutcomePage.vue?vue&type=template&id=20ff046e&"
import script from "./invoicesOutcomePage.vue?vue&type=script&lang=ts&"
export * from "./invoicesOutcomePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports